import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-55669fdc"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "terminal-distribution-chart-wrap" }
const _hoisted_2 = {
  key: 0,
  class: "chart-wrapper"
}

import { ref, computed, watch, onMounted, onUnmounted, nextTick } from 'vue'
import { useI18n } from 'vue-i18n'
import { useReflectiveInjector } from '@tanbo/vue-di-plugin'
import * as echarts from 'echarts'
import { ResizeService } from '@/services/resize.service'
import { getAssignPieOption } from '@/utils/echarts-option/pie'
import { useEchartsThemeSync } from '@/composables/use-echarts-theme-sync'
import { getOverviewPieSliceColor } from '@/views/dashboard/overview/_components/overview-pie-distribution'
import EmptyData from '@/views/dashboard/_components/empty-data/empty-data.vue'
import PieCenter from '@/views/dashboard/_components/echarts/pie-center.vue'
import type { TerminalDistributionItem } from '../../types'


export default /*#__PURE__*/_defineComponent({
  __name: 'terminal-distribution-chart',
  props: {
    data: { default: () => [] },
    centerTitle: { default: '' },
    unit: { default: '' }
  },
  setup(__props: any) {

const { t, locale } = useI18n()

const props = __props

const resolvedCenterTitle = computed(() => {
  void locale.value
  return props.centerTitle || t('overviewZone.chartTerminalCount')
})
const resolvedUnit = computed(() => {
  void locale.value
  return props.unit || t('overviewZone.unitTai')
})

const injector = useReflectiveInjector([ResizeService])
const resizeService = injector.get(ResizeService)

const chartRef = ref<HTMLElement>()
let chartInstance: echarts.EChartsType | null = null

const totalCount = computed(() => props.data.reduce((sum, item) => sum + item.value, 0))

/** 与威胁类型分布一致：无有效数量时不展示饼图 */
const hasChartData = computed(() => props.data.some(item => Number(item.value) > 0))

function initChart () {
  if (!chartRef.value) return
  chartInstance = echarts.init(chartRef.value)
  renderChart()
  nextTick(() => {
    chartInstance?.resize()
  })
}

function renderChart () {
  if (!chartInstance || !hasChartData.value) return

  const pieData = props.data.map((item, index) => ({
    name: item.name,
    value: item.value,
    itemStyle: { color: getOverviewPieSliceColor(item.name, index) },
  }))

  const option = {
    series: [{
      data: pieData,
      name: t('overviewZone.chartSeriesCount'),
    }],
  }

  const finalOption = getAssignPieOption(option, { unit: resolvedUnit.value })
  chartInstance.setOption(finalOption)
}

const resizeSubscribe = resizeService.resizeSubject.subscribe(() => {
  chartInstance && chartInstance.resize()
})

watch(
  () => props.data,
  () => {
    if (!hasChartData.value) {
      chartInstance?.dispose()
      chartInstance = null
      return
    }
    if (!chartInstance) {
      nextTick(initChart)
    } else {
      renderChart()
    }
  },
  { deep: true },
)

watch(locale, () => {
  if (hasChartData.value) {
    nextTick(() => renderChart())
  }
})

onMounted(() => {
  if (hasChartData.value) {
    nextTick(initChart)
  }
})

onUnmounted(() => {
  resizeSubscribe.unsubscribe()
  chartInstance && chartInstance.dispose()
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (hasChartData.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createElementVNode("div", {
            ref_key: "chartRef",
            ref: chartRef,
            class: "chart"
          }, null, 512),
          _createVNode(PieCenter, {
            title: resolvedCenterTitle.value,
            value: totalCount.value,
            unit: resolvedUnit.value
          }, null, 8, ["title", "value", "unit"])
        ]))
      : (_openBlock(), _createBlock(EmptyData, {
          key: 1,
          height: "292px",
          "bg-color": "transparent"
        }))
  ]))
}
}

})